module.exports = __webpack_public_path__ + "static/media/logo.d68d2428.svg";